<template>
  <div class="col-xs-12 " :class="{'col-sm-6 col-md-6 col-lg-4 longer':resultView, 'col-sm-6 col-md-4 col-lg-3':!resultView}">
    <div class="flip-container">
      <div class="flip-card" :class="{'flipped': uploaded}">
        <el-tooltip v-if="document.description || document.templateDescription" v-model="showTip" placement="right">
          <div slot="content" style="width: 200px; font-size: 120%">          
            <div v-if="document.description" class="row" style="padding-bottom: 10px">
              <div class="col-xs-1"><i class="fa fa-exclamation" /></div>
              <div class="col-xs-10">{{document.description}}</div>
            </div>         
            <div v-if="document.templateDescription" class="row" style="padding-bottom: 10px">
              <div class="col-xs-1"><i class="fa fa-exclamation" /></div>
              <div class="col-xs-10">{{document.templateDescription}}</div>
            </div>      
            <div v-if="document.template" class="row">
              <div class="col-xs-1"><i class="fa fa-download" /></div>
              <div class="col-xs-10"><a :href="document.template" target="_blank" download style="color:white"><u>DOWNLOAD</u></a></div>
            </div> 
          </div>
          <div class="front card document-card" :data-background-color="frontColor">
            <div class="document-card-content">
              <span v-if="document.required" class="text-danger required-tild">*</span>
              <button @click.prevent="flashTip" class="btn btn-simple btn-default tip" :class="{'text-danger': errors.has('docs' + validationScope + '.' + document.name)}"><i class="fa fa-question"></i></button>
              <div class="card-header text-center">
                <h5 class="card-title">
                  <i class="fa fa-3x" :class="[faicon]" /><br>
                  <div class="document-card-title">{{document.name}}</div>
                </h5>    
              </div>
              
              <div class="card-content">
                <div v-if="!uploaded && !document.fake">
                  <base64-uploader @data="upload" :name="document.name" :inError="errors.has('docs' + validationScope + '.' + document.name)" v-validate:uploaded="'requiredDoc'" :data-vv-scope="'docs' + validationScope"/>
                  <small><br/><a v-if="mustDownload" @click="downloaded = true" :href="document.template" target="_blank" download><i class="fa fa-download"></i>Download & Sign</a></small>
                </div>
                <div v-else class="btn btn-wd btn-default"><i class="fa fa-upload"></i>&nbsp;Upload</div>
                <small class="text-danger" v-show="errors.has('docs' + validationScope + '.' + document.name)">
                  <br/>{{ errors.first('docs' + validationScope + '.' + document.name) }}
                </small>
              </div>
            </div>
          </div>
        </el-tooltip>
        <div v-else class="front card document-card" :data-background-color="frontColor">
          <div class="document-card-content">
            <span v-if="document.required" class="text-danger required-tild">*</span>
            <div class="card-header text-center">
              <h5 class="card-title">
                <i class="fa fa-3x" :class="[faicon]" /><br>
                <div class="document-card-title">{{document.name}}</div>
              </h5>
            </div>
            <div class="card-content">
              <base64-uploader v-if="!uploaded" @data="upload" :name="document.name" :inError="errors.has('docs' + validationScope + '.' + document.name)" v-validate:uploaded="'requiredDoc'" :data-vv-scope="'docs' + validationScope"/>
              <div v-else class="btn btn-wd btn-default"><i class="fa fa-upload"></i>&nbsp;Upload</div>
              <small class="text-danger" v-show="errors.has('docs' + validationScope + '.' + document.name)">
                <br/>{{ errors.first('docs' + validationScope + '.' + document.name) }}
              </small>
            </div>
          </div>
        </div>

        <div class="back card document-card" :data-background-color="backColor">
          <div class="document-card-content">
            <div class="card-header text-center unset-header">
              <h5 class="card-title">
                <i class="fa fa-3x" :class="[faicon]" /><br>
                <div class="document-card-title">{{document.name}}</div>
              </h5>
            </div>
            <div class="card-content">
              <button @click.prevent="download" class="btn btn-fill">View</button>
              <button v-if="canDelete" @click.prevent="del" class="btn btn-fill">Delete</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Base64Uploader from 'src/components/Inputs/Base64Uploader'
  import b64toBlob from 'b64-to-blob'
  import { Validator } from 'vee-validate';
  
  export default {
    name: 'document-card',
    components: {
      Base64Uploader
    },
    inject: ['$validator'],
    props: {
      document: Object,
      resultView: {type: Boolean, default: false },
      canAdd: { type: Boolean, default: false },
      canDelete: { type: Boolean, default: false },
      mustDownload: { type: Boolean, default: false },
      validationScope: {type: String, default: ''},
      deleteData: Function
    },
    data () {
      return {
        working: false,
        showTip: false,
        downloaded: false,
        backColor: "success"
      }
    },
    computed: {
      frontColor () {
        return this.errors.has('docs' + this.validationScope + '.' + this.document.name) ? "error" : "grey" 
      },
      uploaded () {
        return this.document.id != null || this.document.data != null
      },
      faicon () {
        if(this.document.name == 'Consent Form') return 'fa-check-square-o'
        if(this.document.name == 'Degree or Diploma Certificate') return 'fa-graduation-cap'
        if(this.document.name == 'Copy of the Diploma or Certificate') return 'fa-graduation-cap'
        if(this.document.name == 'Photo Identification or Passport') return 'fa-id-card-o'
        if(this.document.name == 'All year marksheet/transcript') return 'fa-file-text-o'
        if(this.document.name == 'Add a document') return 'fa-plus'
        return 'fa-file-o'
      }
    },
    created() {
      if(this.document.required) {
        this.$validator.extend('requiredDoc', {
          validate(value, args) {
            return value
          },
          getMessage(field, args) {
            return "This document is required"
          } 
        })
      }
    },
    methods: {
      flashTip () {
        this.showTip = false
        setTimeout(() => {
          this.showTip = true
        }, 100)
      },
      upload (filename, base64Data) {
        // if(this.document.verificationId) {
        //   this.working = true
        //   this.$api.postDocument(this.document.verificationId, {
        //     name: this.document.name,
        //     data: base64Data
        //   }).then(response => {
        //     this.document.id = response.data.id
        //     this.document.filename = response.data.filename
        //     this.working = false
        //   }).catch(error => {
        //     console.log("Failed to upload document for existing verification " + this.document.verificationId)
        //     this.working = false
        //   })
        // } else {
          this.document.filename = filename
          this.document.data = base64Data
        // }
      },
      download () {
        this.working = true
        if(this.document.data) {
          this.doDownload(b64toBlob(this.document.data, 'application/octet-stream'))
          this.working = false
        } else {
          var ownerId = this.document.verificationId
          var ownerType = 'verification'
          if(!ownerId) {
            ownerId = this.document.applicationId
            ownerType = 'application'
          }
          this.$api.getDocument(ownerType, ownerId, this.document.id)
            .then(response => {
              this.doDownload(new Blob([response.data], { type: 'application/octet-stream' }))
              this.working = false
            })
            .catch(error => {
              this.working = false
              console.log("Failed to download doc")
              console.log(error)
            })
        }
      },
      doDownload (blob) {
        var filename = this.document.filename;
        if(window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            var link = document.createElement('a');
            var url = window.URL.createObjectURL(blob);
            link.href = url;
            link.download = filename;
            link.target= "_blank";
            document.body.appendChild(link);
            link.click();
            setTimeout(function(){
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }, 100); 
        }
      },
      del () {
        this.working = true
        // this.deleteData(this.document)
        // .then(response => {
          this.document.id = null
          this.document.filename = null
          this.document.data = null
          this.working = false
          if(!this.document.required) {
            this.$emit('deleted')
          }
        // })
        // .catch(error => {
        //   console.log(error)
        //   this.working = false
        // })
      },
      rm () {
        this.$emit('deleted')
      }
    }
  }
</script>

<style>
  .unset-header{
    background: unset !important;
    color: unset !important;
    border-bottom: unset !important;
    padding-bottom: unset !important;
  }
  .card-title i {
    width: auto
  }
  .required-tild {
    position: absolute;
    top: 0px;
    left: 10px;
    font-size: 200%;
  }
  .tip {
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 4;
  }
  .document-card {   
    position: relative;
    width: 100%;
    height: 200px;
  }
  .longer .document-card {   
    height: 250px !important;
  }
  .document-card:before {   
    border-bottom-left-radius: 4px;
    border-width: 20px;
    display: block;
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
  }
  .front.document-card:before {   
    border-color: #fff #fff rgba(1,1,1,.35) rgba(1,1,1,.35);
  }
  .back.document-card:before {   
    border-color: #fff #fff rgba(255,255,255,.35) rgba(255,255,255,.35);
  }
  .document-card-title {   
    height: 50px;
  }
  .longer .document-card-title {   
    height: 80px;
  }
  .document-card-content {
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: hidden;
    margin-bottom: 10px;
  }
  .document-card-content .card-header {
    padding-top: 10px !important;
  }
  .document-card-content .card-header .card-title {
    margin-bottom: 10px !important;
  }
  .document-card-content .card-content {
    padding-top: 0 !important;
  }
  .document-card-content .card-content .help-block {
    text-align: left;
    font-size: 75%;
    padding-top: 0;
    margin-bottom: 0;
  }
  .flip-container {
    margin-bottom: 20px;
    position: relative;
    width: 100%;
    height: 200px;
    -webkit-perspective: 800px;
    -moz-perspective: 800px;
    -o-perspective: 800px;
    perspective: 800px;
  }
  .longer .flip-container {
    height: 220px;
  }
  .flip-card {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      -webkit-transition: -webkit-transform 1s;
      -moz-transition: -moz-transform 1s;
      -o-transition: -o-transform 1s;
      transition: transform 1s;
      -webkit-transform-style: preserve-3d;
      -moz-transform-style: preserve-3d;
      -o-transform-style: preserve-3d;
      transform-style: preserve-3d;
      -webkit-transform-origin: 50% 50%;
  }
  .flip-card .document-card {
      display: block;
      height: 100%;
      width: 100%;
      position: absolute;
      -webkit-backface-visibility: hidden;
      -moz-backface-visibility: hidden;
      -o-backface-visibility: hidden;
      backface-visibility: hidden;
  }
  .flip-card .front {
     z-index: 0
  }
  .flip-card .back {
      z-index: 1;
      -ms-transform: rotateY( -180deg );
      -webkit-transform: rotateY( -180deg );
      -moz-transform: rotateY( -180deg );
      -o-transform: rotateY( -180deg );
      transform: rotateY( -180deg );
  }
  .flip-card.flipped {
      -ms-transform: rotateY( -180deg );
      -webkit-transform: rotateY( -180deg );
      -moz-transform: rotateY( -180deg );
      -o-transform: rotateY( -180deg );
      transform: rotateY( -180deg );
  }
  .flip-card.flipped .back {
      -ms-backface-visibility: visible;
  }
</style>
